import React from 'react';
import { Avatar } from '@components/basics/Images/Avatar';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { VerifiedTooltip } from '@components/main-components/tooltip/VerifiedTooltip';
import { DEFAULT_DOMINANT_BACKGROUND_COLOR } from '@utils/constants';
import { webappUriPath } from '@utils/url';
import { UserCardS } from './UserCardS';

export const UserCard = ({
  coverImageSrc,
  webappUri,
  label,
  metadata,
  name,
  showVerified,
  publicAddress,
  showSBackground,
  dominantColor = DEFAULT_DOMINANT_BACKGROUND_COLOR, //base600 in hex
}: {
  coverImageSrc: string | undefined;
  webappUri: string;
  label: 'Artist' | 'Collector';
  metadata: string | undefined;
  name: string;
  showVerified: boolean;
  publicAddress: string;
  showSBackground: boolean;
  dominantColor: string | undefined;
}) => {
  return (
    <AccessibleLink
      pathnameUri={webappUriPath(webappUri)}
      className="group relative block h-fit max-h-fit w-full transform-gpu overflow-hidden rounded-lg bg-black"
    >
      <div
        className="relative flex aspect-square w-full items-center justify-center"
        style={{ backgroundColor: dominantColor }}
      >
        <div className="relative z-above1 p-4">
          <Avatar
            size={140}
            src={coverImageSrc}
            borderRadius="50%"
            disableLink
            walletAddress={publicAddress}
            webappUri={webappUri}
            scaleOnHover
          />
        </div>
        {showSBackground && (
          <div className="absolute left-0 top-0 h-full w-full [&_svg]:w-full">
            <UserCardS />
          </div>
        )}
        <div className="pointer-events-none absolute bottom-0 z-base h-28 w-full transform-gpu bg-gradient-to-t from-black" />
      </div>
      <div className="flex flex-col gap-1 px-3 pb-3 pt-1 text-base-s text-base400">
        <span>{label}</span>
        <h6 className="flex max-w-full items-center gap-1 font-title text-title-m font-medium text-white">
          <span className="overflow-hidden text-ellipsis whitespace-nowrap">{name}</span>
          {showVerified && <VerifiedTooltip noTooltip size={16} />}
        </h6>
        {metadata && <div>{metadata}</div>}
      </div>
    </AccessibleLink>
  );
};
